import Immutable from 'immutable';

/**
 * Throw an error if there is no state key provided
 * @param {Object} action The action object
 * @private
 */
const _checkStateKey = (action) => {
    if (!action.stateKey) {
        throw new Error(`Action sent to form reducer has no stateKey: ${JSON.stringify(action)}`);
    }
};

/**
 * H&C Specific form reducers
 * @type {Object}
 */
export const formReducerCases = {
    SET_SHIELDED_FIELDS: (state, action) => {
        _checkStateKey(action);
        const contactDetails = state.get('contactDetails');
        const policyHolder = state.get('policyHolder');
        return state.merge({
            shielded: {
                mobile: contactDetails.get('mobile'),
                phone: contactDetails.get('phone'),
                name: `${policyHolder.get('firstName')} ${policyHolder.get('lastName')}`,
                postcode: state.get('property').get('address').get('postcode')
            }
        });
    },
    GET_YEAR_BUILT_VALUES: (state, action) => {
        _checkStateKey(action);
        const startYear = 2010;
        const currentYear = (new Date()).getFullYear();
        const yearDiff = currentYear - startYear;

        // Create an array for our values which are provided to the year_built_recent question
        // This question needs to add a new option as the years increment, e.g. on January 1 2020, the 2020 option is available
        const yearBuiltValues = (new Array(yearDiff))
            // Array.map() doesn't work on an array of empty values
            .fill(null)

            // Turn it into an array of...
            // Objects which now contain { value, label }
            .map((_, index) => (
                {
                    value: (currentYear - index).toString(),
                    label: (currentYear - index).toString()
                }
            ));

        return state.mergeDeep({
            helpers: { yearBuiltValues }
        });
    },
    UPDATE_OCCUPANCYTYPE_WHEN_PSEUDO_LANDLORD: (state, action) => {
        // Only a home owner can be transformed into a pseudo landlord. This action allows a home
        // owner to change to a landlord when 'Rented to tenants' is selected. If they change their
        // answer off 'Rented to tenants' they will change to a home owner again.
        _checkStateKey(action);
        const howOccupied = state.getIn(['occupancy', 'howOccupied']);
        const isPrincipalResidence = state.getIn(['occupancy', 'isPrincipalResidence']);
        const occupancyType = state.getIn(['occupancy', 'occupancyType']);

        // Do nothing if user is a tenant or coming from the first page with Landlord selected
        // (selecting landlord will set isPrincipalResidence to null)
        if (occupancyType === 'TENANT' || isPrincipalResidence === null) {
            return state;
        }

        // Only change to landlord if 'Rented to tenants' is selected.
        if (howOccupied === 'RENTED_TO_TENANTS') {
            return state.setIn(['occupancy', 'occupancyType'], 'LANDLORD');
        }
        return state.setIn(['occupancy', 'occupancyType'], 'OWNER');
    },
    CLEAR_HOW_OCCUPIED_ON_PPOR_CHANGE: (state, action) => {
        // Clear howOccuped when PPOR changes. This allows the user to go from 'pseudo landlord' back to
        // a home owner. Without this action the user is permanently stuck as a LANDLORD and the
        // visible questions do not change back.
        _checkStateKey(action);
        const occupancyType = state.getIn(['occupancy', 'occupancyType']);
        const isPrincipalResidence = state.getIn(['occupancy', 'isPrincipalResidence']);
        if (occupancyType === 'LANDLORD' && isPrincipalResidence) {
            return state.setIn(['occupancy', 'occupancyType'], 'OWNER');
        }
        return state.setIn(['occupancy', 'howOccupied'], null);
    }
};
